import React from 'react';

const SelectFilter = ({ options, selectedValue, setSelectedValue }) => {
  return (
    <select
      value={selectedValue}
      onChange={(e) => setSelectedValue(e.target.value)}
      className="custom-select"
    >
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};

export default SelectFilter; 